module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Hermann Cohen and the Crisis of Liberalism")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/9780253039767_template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "CONTENTS"
    }
  }, [_c('p', {
    staticClass: "h2",
    attrs: {
      "id": "con"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "top5"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039767_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "top1"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rabb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039767_Abbreviations"
    }
  }, [_c('i', [_vm._v("List of Abbreviations for Frequently Cited Sources")])])]), _vm._v(" "), _c('div', {
    staticClass: "top_1"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039767_Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253039767_Introduction"
    }
  }, [_c('i', [_vm._v("Religion, Reason, and the Enchanted Public Sphere")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minor Protest(ant)s")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cohen and German-Jewish Liberalism")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dialectic of Enchantment")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Science, Religion, and Secular Reasoning")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rights, Religion, and Race")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Cohen’s Ethical Socialism and the Specter of Anti-Semitism")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_3",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.")]), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enchanted Reasoning")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Self-Reflexive Religion and Minority")])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rconc"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Some Minor Reflections of Enchantment")])])]), _vm._v(" "), _c('div', {
    staticClass: "top_1"
  }, [_c('p', {
    staticClass: "toc_1",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253039767_Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-861c3dcc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253039767_Contents.vue
// module id = 72
// module chunks = 0